import { render, staticRenderFns } from "./menu-popup.vue?vue&type=template&id=6482783a&scoped=true&"
import script from "./menu-popup.vue?vue&type=script&lang=ts&"
export * from "./menu-popup.vue?vue&type=script&lang=ts&"
import style0 from "./menu-popup.vue?vue&type=style&index=0&id=6482783a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6482783a",
  null
  
)

export default component.exports